const Button = ({ type, onClick, disabled, btnClassName, children }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={btnClassName}
    >
      {children}
    </button>
  );
};

export default Button;
